
import * as React from 'react';
import { emphasize, styled } from '@mui/material/styles';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Chip from '@mui/material/Chip';
import { paramsQuerryChekerUrlTagName } from '../../../DisplayComponent';

const StyledBreadcrumb = styled(Chip)(({ theme }) => {
  let backgroundColor = "#fb8c16";
  let backgroundColorH = "#fdf6ec";
  return {
    backgroundColor: backgroundColorH,
    height: theme.spacing(4),
    color: backgroundColor,
    fontWeight: theme.typography.fontWeightRegular,
    cursor: "pointer",
    textDecoration: "none !important",
    borderRadius: "5px",
    '&:hover, &:focus': {
      backgroundColor: backgroundColor,
      color: backgroundColorH,
    },
    '&:active': {
      boxShadow: theme.shadows[1],
      backgroundColor: backgroundColor,
      color: backgroundColorH,
    },
  };
}); // TypeScript only: need a type cast here because https://github.com/Microsoft/TypeScript/issues/26591

function handleClick(event) {
  event.preventDefault();
 
  if (event.target.parentNode.href != window.location.href) {
    window.location.href = event.target.parentNode.href;
  }

}

const BreadcrumbsCustom = (props) => {

  const [valueTagName, setTagName] = React.useState(paramsQuerryChekerUrlTagName(props));
  return (
    <div role="presentation" >
      <Breadcrumbs aria-label="breadcrumb" separator="→" sx={{ mb: 5, pl: 0 }}>
        <StyledBreadcrumb
          component="a"
          href="/"
          label="Главная"
          onClick={handleClick}
        />
        <StyledBreadcrumb component="a" href= {!valueTagName == "" ? `/${props.catalogUrl}/` : ""} label="Каталог"  onClick={handleClick}/>
        {!valueTagName == "" &&
          (<StyledBreadcrumb component="span" href="#" label={valueTagName} />)
        }
      </Breadcrumbs>
    </div>
  );
}

export default BreadcrumbsCustom;